import React from "react"
import { FlatFilePicker as JBFilePicker } from "shared/ui/berry-jass"
import { fieldToFilePicker } from "./FilePicker"

export const FlatFilePicker = (props) => {
  return <JBFilePicker {...fieldToFilePicker(props)} />
}
